import { z } from 'zod';

// Initiative entity
export const InitiativeSchema = z.object({
  id: z.string().min(1),
  title: z.string().min(1),
  description: z.string().default(''),
  objective: z.string().optional().default(''),
  keyResults: z.array(z.string()).optional().default([]),
  strategicAlignment: z.string().optional(),
  owner: z.string().optional(),
  status: z.string().optional(),
  priority: z.string().optional(),
  progress: z.number().optional(),
  strategicFit: z.number().optional(),
  tags: z.array(z.string()).optional().default([]),
  // Impact Mapping terminology (single canonical field)
  stakeholders: z.array(z.string()).optional().default([]),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional()
});

// Strategy entity (simplified)
export const StrategyPillarSchema = z.object({
  name: z.string().min(1),
  description: z.string().optional().default(''),
  goals: z.array(z.string()).optional().default([])
});

export const StrategySchema = z.object({
  id: z.string().optional(),
  type: z.enum(['uploaded', 'emergent']).optional().default('uploaded'),
  vision: z.string().optional(),
  mission: z.string().optional(),
  values: z.array(z.string()).optional().default([]),
  pillars: z.array(StrategyPillarSchema).optional().default([]),
  metadata: z.record(z.any()).optional().default({})
});

// Prompt (custom prompt definition minimal)
export const PromptSchema = z.object({
  systemRole: z.string(),
  temperature: z.number().min(0).max(1).default(0.7),
  maxTokens: z.number().optional()
});
